export const environment = {
  production: false,
  name: "Trail Fusion - Staging",
  verificationRedirectUrl:
    "https://staging-parent-portal.trailfusion.net/sign-in",

  baseUrl: "https://staging-parent-portal.trailfusion.net",
  apiUrl:
    "https://us-central1-staging-parent-portal.cloudfunctions.net/api/parent",
  apiUrlNewCall:
    "https://us-central1-staging-parent-portal.cloudfunctions.net/api/",
  apiUrlCache:
    "https://us-central1-staging-parent-portal.cloudfunctions.net/api/cache",
  apiUrlMail:
    "https://us-central1-staging-parent-portal.cloudfunctions.net/api/mail",
  adminPortalUrl: "https://staging-admin-portal.trailfusion.net/sign-in",
  stripePublishableKey:
    "pk_live_51RwRdKFHrZqLehUf6WnqpnDLdnyUt9FSiVcv6Mm8lmgpzufjogjLSwmlhFDL4PbiYj5OzusK3xVXXWgq7IwgZMYc0050PA03XW",
  authorizeNet: {
    apiLoginId: "52Fb7w4XNa",
    clientKey:
      "57fUvnLK4V9qZKganv238c2rZ2rQ26RvVEgx6g7K4bk6tYPFhXeY822wLFXe2zYM",
    environment: "sandbox",
  },
  firebase: {
    apiKey: "AIzaSyCFTwf3h0kTjydEaJpXKdO29EbHh--5ldQ",
    authDomain: "staging-parent-portal.firebaseapp.com",
    projectId: "staging-parent-portal",
    storageBucket: "staging-parent-portal.firebasestorage.app",
    messagingSenderId: "882441690295",
    appId: "1:882441690295:web:5d53c8dac4851d46f84132",
    measurementId: "G-W2F3S5ZKRS",
  },
  ipifyUrl: "https://api.ipify.org/?format=json",
  ipinfoUrl: "https://ipinfo.io/",
  ipinfoToken: "?token=abe7cb4c38b788",
  getClientIPAddressByIpify: "getClientIPAddressByIpify",
};
